/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { Get8Params, PerksProviderDto } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class ApiPerksProviders<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-perks-providers
   * @name Get8
   * @request GET:/api/v1/perks/providers
   */
  get = (query: Get8Params, params: RequestParams = {}) =>
    this.http.request<PerksProviderDto[], any>({
      path: `/v1/perks/providers`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getPath = '/v1/perks/providers'
  static getMethod = 'GET'
}
